import { Modal } from "@components/shared/modal";

import { Configurator } from "./configurator";
import { ConfiguratorProvider } from "./context";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const UniversalBenchmarksModal = ({ isOpen, onClose }: Props) => {
  return (
    <Modal
      variant="v2"
      isOpen={isOpen}
      onClose={onClose}
      contentClassName="max-w-[1300px] max-h-[900px]"
    >
      <ConfiguratorProvider>
        <Configurator onComplete={onClose} />
      </ConfiguratorProvider>
    </Modal>
  );
};
